import { render, staticRenderFns } from "./ModalLancarPedido.vue?vue&type=template&id=ddfa4e58&"
import script from "./ModalLancarPedido.vue?vue&type=script&lang=js&"
export * from "./ModalLancarPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports